import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import { Market } from 'generated/event.types';

const useMarketOptions = (includeAll = true) => {
  const { t } = useTranslation();

  const marketsToFilter = [Market.uk, Market.ch];

  const marketKeys = Object.keys(Market).filter((market) => !marketsToFilter.includes(market as Market));
  const marketValues: Market[] = Object.values(Market).filter((market) => !marketsToFilter.includes(market as Market));
  const flags = useFlags();
  const marketOptions = marketValues.map((value, index) => {
    const marketLabel = value === Market.com && flags.eventsBiogenlinc5399SwissMarketIntoTheBo
      ? t('market_label_com_ch') : t(`market_label_${value}`);

    return { id: marketKeys[index], label: marketLabel };
  });

  if (includeAll && flags.eventsCweb770ShowAllOptionToViewAllEvents) {
    marketOptions.push({ id: 'all', label: 'All' });
  }

  return marketOptions;
};

export default useMarketOptions;
